module.exports = __webpack_public_path__ + "assets/orange-lg-logo-b47ff6.svg";